import { Component, OnInit } from '@angular/core';
import { InitService } from '../services/init.service';

@Component({
  selector: 'app-incidencias',
  templateUrl: './incidencias.component.html',
  styleUrls: ['./incidencias.component.css']
})
export class IncidenciasComponent implements OnInit {
  constructor(private serviceInit: InitService) {
    this.serviceInit.setEstadoLayout(true);
  }

  ngOnInit(): void {}
}
